import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import ParagraphTranslatable from 'components/ParagraphTranslatable/ParagraphTranslatable';
import { sortByKey } from 'helpers/helpers';

const useStyles = makeStyles({
  ...extendedFormsStyle,
  ...buttonsStyle,
});

const SuperVariantBetaPricesTable = props => {
  const { t } = useTranslation();
  const { state, setState, multinational } = props;

  const classes = useStyles();

  const calories = state.variant.calories || [];
  const mealTypes = state.variant.mealTypes || [];

  const handleInputChange = ({ event, mealType, calorific }) => {
    const findCalorific = state.variant.calories.find(
      el => el.key === calorific.key
    );

    const findSuperVariant = findCalorific.superVariantMealType.find(
      superVariant => superVariant.mealType === mealType['@id']
    );

    // eslint-disable-next-line no-shadow -- FIXME
    const newValue = calories.map(calories => {
      if (calories.key === findCalorific.key) {
        return {
          ...calories,
          superVariantMealType: calories.superVariantMealType.map(
            superVariant => {
              if (
                superVariant.id === findSuperVariant.id &&
                superVariant.mealType === mealType['@id']
              ) {
                return {
                  ...superVariant,
                  resignPrice: parseFloat(event.target.value),
                };
              }
              return superVariant;
            }
          ),
        };
      }
      return calories;
    });

    setState(prevValue => ({
      ...prevValue,
      variant: {
        ...prevValue.variant,
        calories: newValue,
      },
    }));
  };

  useEffect(() => {
    const rawMealTypes = mealTypes.map(mealType => mealType?.['@id']);

    const notCorrectCalories = calories.filter(
      el => mealTypes.length !== el.superVariantMealType.length
    );
    if (notCorrectCalories.length === 0) {
      return;
    }

    const initialNewSuperVariant = calories.map(prevCalorific => {
      if (mealTypes.length > prevCalorific.superVariantMealType.length) {
        const mealTypeToAdd = mealTypes
          .map(mealType => {
            if (
              !prevCalorific.superVariantMealType.find(
                el => el.mealType === (mealType?.['@id'] || mealType)
              )
            ) {
              return {
                mealType: mealType['@id'],
                resignPrice: 0,
              };
            }
            return null;
          })
          .filter(el => el !== null);

        return {
          ...prevCalorific,
          superVariantMealType: [
            ...prevCalorific.superVariantMealType,
            ...mealTypeToAdd,
          ],
        };
      }
      return {
        ...prevCalorific,
        superVariantMealType: prevCalorific.superVariantMealType.filter(
          superVariantMealType =>
            rawMealTypes.includes(superVariantMealType.mealType)
        ),
      };
    });

    setState(prevValue => ({
      ...prevValue,
      variant: {
        ...prevValue.variant,
        calories: initialNewSuperVariant,
      },
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [mealTypes]);

  const pickMealType = (mealType, calorific) =>
    calorific.superVariantMealType.find(
      el =>
        (el.mealType?.['@id'] ?? el.mealType) ===
        (mealType?.['@id'] ?? mealType)
    );

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell></TableCell>

          {mealTypes.map(mealType => (
            <TableCell key={mealType.id}>{mealType.name}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {sortByKey(calories, 'position').map(calorific => (
          <TableRow key={calorific.id}>
            <TableCell rowSpan={1}>
              <ParagraphTranslatable value={calorific.name} />
              {calorific.workName &&
                calorific.name !== calorific.workName &&
                `(${calorific.workName})`}
            </TableCell>
            <TableCell>
              {t('form.field.variant.superVariant.beta.value')} [
              {multinational.currency}]
            </TableCell>
            {mealTypes.map(mealType => (
              <TableCell key={mealType.id}>
                <FormTextInput
                  classes={classes}
                  name="minPrice"
                  type="number"
                  value={pickMealType(mealType, calorific)?.resignPrice || 0}
                  handleChange={e => {
                    handleInputChange({
                      event: e,
                      mealType,
                      calorific,
                    });
                  }}
                  inputSize={12}
                  maxLength={6}
                  inputProps={{ min: 0 }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SuperVariantBetaPricesTable;
